<template>
	<!-- DEV: State isn't needed for this card, please remove any logic related ('is-' + snippetState.class) -->
	<div class="snippet-summary-card">
		<div class="snippet-summary-card__body">
			<p class="snippet-summary-card__title">
				{{ snippet.id }}
				<span class="snippet-summary-card__divider">|</span>
				<Ellipsis :data="snippet.description"></Ellipsis>
			</p>
			<Ellipsis
				class="snippet-summary-card__data"
				:data="snippet.snippetCalc"
				v-if="snippet.snippetCalc"
			></Ellipsis>

			<span class="snippet-summary-card__sync" :title="snippetStatus">
				{{ snippetStatus }}
			</span>
		</div>

		<div class="snippet-summary-card__footer">
			<ActionsSet
				class="snippet-summary-card__actions"
				:id="`${uid}_action`"
				:variant="variant"
				:options="actions"
			/>
		</div>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import Ellipsis from '@/components/visual/ellipsis';
export default {
	name: 'CodeManagerCard',
	components: {
		ActionsSet,
		Ellipsis
	},
	data() {
		return {
			tooltipTitleVisible: false,
			tooltipDataVisible: false
		};
	},
	props: {
		snippet: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		settingsSnippetDisabled() {
			return this.validatePermission('forms.update'); //TODO research proper permission
		},
		countForms() {
			return this.snippet.forms.length;
		},
		isActive() {
			return this.snippet.forms.length > 0;
		},
		actions() {
			return this.calcActions();
		},
		snippetState() {
			return {
				class: 'active',
				icon: 'checkbox',
				title: ''
			};
		},
		snippetStatus() {
			return this.snippet.status === 'U'
				? 'Unpublished'
				: this.snippet.status === 'P'
				? 'Pending Changes'
				: '';
		},
		cardTitleTooltipText() {
			return `${this.snippet.id} | ${this.snippet.description}`;
		}
	},
	methods: {
		codeForms() {
			let code = { ...this.snippet };
			this.$store.dispatch('codemanager/codeSelectedDetails', code);
			this.$store.dispatch('codemanager/showFormsModal', true);
		},
		codeNewCopySettings() {
			let copiedCode = { ...this.snippet };
			copiedCode.sourceOfSelection = 'CodeManagerCard';
			this.$store.dispatch('codemanager/codeSelected', copiedCode);
		},
		showCodeDetailsModal() {
			let code = { ...this.snippet };
			this.$store.dispatch('codemanager/codeSelectedDetails', code);
			this.$store.dispatch('codemanager/showCodeDetailModal', true);
		},
		calcActions() {
			let cardActions = [
				{
					id: 0,
					action: this.showCodeDetailsModal,
					disabled: false,
					iconClass: 'icon icon-show',
					label: 'Details',
					title: 'Opens the Code Settings (Details) Popup.',
					type: 'anchor',
					visible: true
				},
				{
					id: 1,
					action: this.codeForms,
					disabled: !this.isActive,
					iconClass: 'icon icon-document',
					label: 'Forms',
					title: 'Open the Forms Popup',
					type: 'anchor',
					visible: true,
					valueBadgeCount: this.countForms
				},
				{
					id: 2,
					action: {
						path: `/forms/code/${this.snippet.id}/history`
					},
					disabled: false,
					iconClass: 'icon icon-history',
					label: 'History',
					title: 'Select to go to Code history',
					type: 'route-link',
					visible: true
				}
			];

			if (this.snippet.canBeUpdated) {
				cardActions.splice(0, 1, {
					id: 0,
					action: this.codeNewCopySettings,
					disabled: false,
					iconClass: 'icon icon-manage',
					label: 'Settings',
					title: 'Opens the Code Settings (Details) Popup.',
					type: 'anchor',
					visible: true
				});
			}

			return cardActions;
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Snippet Summary Card
		* Can use SCSS variables = TRUE
    *
 */

@import '@/scss/5-objects/_cards.scss';
@import '@/scss/5-objects/_form.scss';

.snippet-summary-card {
	@include card;
	flex-direction: column;
	font-size: $default-font-size - 2;

	&__body {
		cursor: default;
		margin-bottom: $gutter-md;
	}

	&__title {
		width: 100%;
		display: inline-flex;
		flex-direction: row;
		@include heading('md');
		text-transform: capitalize;
	}

	&__data {
		margin-bottom: $gutter-md;
	}

	&__divider {
		color: $neutral-3;
		font-weight: 300;
		position: relative;
		top: -1px;
		margin: 0 $gutter-sm;
	}

	&__sync {
		text-transform: uppercase;
		font-weight: $medium-font-weight;
		@include text-contrast($page-body-bkgd, $white, $neutral-2);
	}

	&__actions {
		.actions-set .actions-set__item {
			@include mq($until: sm-l) {
				margin-left: 0;
			}
		}

		@include mq($from: lg) {
			margin-left: auto;
		}
	}
}
</style>
